import axios from "axios";

const TOKEN_KEY = "tickted_access_token";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000",
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      "Something went wrong";
    const err = new Error(message) as Error & { code?: string };
    if (error.response?.data?.code) {
      err.code = error.response.data.code;
    }
    return Promise.reject(err);
  }
);

export { TOKEN_KEY };
export default api;
